import { generatePath } from 'react-router-dom';

export const ROUTER_PATHS = {
	root: { path: '/', getLink: () => '/' },
	login: { path: '/login', getLink: () => '/login' },
	purchaseOrders: { path: '/purchase-orders', getLink: () => '/purchase-orders' },
	poDetail: {
		path: '/po/:poId',
		getLink(poId: string) {
			return generatePath(this.path, { poId });
		},
	},
	poLineDetail: {
		path: '/po/:poId/line/:lineId',
		getLink(poId: string, lineId: string) {
			return generatePath(this.path, { poId, lineId });
		},
	},
	itpDetail: {
		path: '/po/:poId/itp',
		getLink(poId: string) {
			return generatePath(this.path, { poId });
		},
	},
	ncrDetail: {
		path: '/po/:poId/ncr/:ncrId',
		getLink(poId: string, ncrId: string) {
			return generatePath(this.path, { poId, ncrId });
		},
	},
} as const;
